var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17a2 2 0 002 2h14.042a2 2 0 001.904-1.388l3.214-10A2 2 0 0019.256 5H18V3.9a2 2 0 00-2-2H7.302a.5.5 0 01-.443-.267l-.297-.564A2 2 0 004.792 0H2a2 2 0 00-2 2v15zM16.75 5V3.9a.75.75 0 00-.75-.75H7.302a1.75 1.75 0 01-1.549-.935l-.297-.564a.75.75 0 00-.663-.401H2a.75.75 0 00-.75.75v13.5l3.276-9.173A2 2 0 016.41 5h10.34zM8.6 9a.6.6 0 00-.6.6v1.8a.6.6 0 00.6.6h1.8a.6.6 0 00.6-.6V9.6a.6.6 0 00-.6-.6H8.6zm3.4 4.6a.6.6 0 01.6-.6h1.8a.6.6 0 01.6.6v1.8a.6.6 0 01-.6.6h-1.8a.6.6 0 01-.6-.6v-1.8zm1.5-1.6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2.545 3.425L9.82 13.203a.354.354 0 00-.64 0l-1.135 2.222c-.132.259.043.575.32.575h2.27c.277 0 .453-.316.32-.575z",
    fill: "#105ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryActive);
export default __webpack_public_path__ + "static/media/directory-active.ad23ef1666313fd007545ad6ec2982d4.svg";
export { ForwardRef as ReactComponent };